import {PureComponent, createRef} from 'react';

import {logger} from 'utils';

type Props = {
    accept?: string;
    onUpload: (binary: any, file: File) => void;
    setInputRef: (ref: React.RefObject<HTMLInputElement>) => void;
};

export class FileInput extends PureComponent<Props> {
    importRef: React.RefObject<HTMLInputElement> = createRef();

    componentDidMount() {
        this.props.setInputRef(this.importRef);
    }

    getFileFromInput = (file: File): Promise<any> => new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.readAsArrayBuffer(file); // here the file can be read in different way Text, DataUrl, ArrayBuffer
    });

    handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        Array.from(event.target.files).forEach((file) => {
            this.getFileFromInput(file)
                .then((binary) => {
                    this.props.onUpload(binary, file);
                }).catch((reason) => {
                    logger.error(`Error during upload ${reason}`);
                }).finally(() => {
                    event.target.value = '';
                });
        });
    };

    render() {
        const {accept} = this.props;
        const {importRef, handleFileChange} = this;
        return (
            <input
                ref={importRef}
                type='file'
                accept={accept}
                className='tw-hidden'
                multiple={false}
                onChange={handleFileChange}
            />
        );
    }
}
